import { VehicleDriver } from 'src/app/pages/pumping/models/pump.model';

export interface DriverManagementDriversRequest {
  initialDate: string;
  endDate: string;
  plantIds: number[];
}

export interface DriverManagementDriver {
  driverId: number;
  driverCode: string;
  driverName: string;
  phoneNumber: string;
  plantId: number;
  plantCode: string;
  plantDesc: string;
  vehicleId?: number;
  equipmentNumber?: string;
  fleetId?: string;
  terminationDate?: string;
}

export interface DriverManagementDriversResponse {
  drivers: DriverManagementDriver[];
}

export const buildDriverManagementDriversKey = (request: DriverManagementDriversRequest): string => {
  const normalizedPlantIds = [...request.plantIds].sort((left, right) => left - right);

  return `initialDate=${request.initialDate}|endDate=${request.endDate}|plantIds=${normalizedPlantIds.join(',')}`;
};

export const mapDriverManagementDriversToVehicleDrivers = (
  response: DriverManagementDriversResponse | null,
): VehicleDriver[] => {
  if (!response?.drivers?.length) {
    return [];
  }

  const seenDriverIds = new Set<number>();

  return response.drivers.reduce<VehicleDriver[]>((drivers, driver) => {
    if (seenDriverIds.has(driver.driverId)) {
      return drivers;
    }

    seenDriverIds.add(driver.driverId);
    drivers.push({
      id: driver.driverId,
      code: driver.driverCode,
      name: driver.driverName,
      countryCode: null,
      telephoneNumber: driver.phoneNumber || null,
      vehicleId: driver.vehicleId,
      equipmentNumber: driver.equipmentNumber,
      fleetId: driver.fleetId,
    });

    return drivers;
  }, []);
};
